import NewIcon from "../../../assets/icons/NewIcon";
import {
  SelectUpgradeAccountType,
  SelectUpgradeAccountTypeProps,
  TierType,
  UpgradeAccountRequest,
} from "../../../types/upgradeAccount";
import { selectUpgradeAcctType } from "../../../utils/constants";
import styles from "../ServiceOffer.module.css";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { saveStepperData } from "../../../redux/stepperSlice";
import { errorToast } from "../../../utils/makeToast";

const SelectAccountUpgradeType: React.FC<SelectUpgradeAccountTypeProps> = ({
  onClickCancel,
}) => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const viewFeatures = !!searchParams.get("view");
  const stepperData = useAppSelector((state) => state.stepper.data);
  const { tierType } = stepperData;

  const handleClickUpgradeAcctType = (
    type: SelectUpgradeAccountType["type"],
    goToPage?: boolean,
  ) => {
    if (type.includes(`3`)) return errorToast("Coming Soon...");

    if (goToPage && !!tierType) {
      searchParams.set("view", "features");
      setSearchParams(searchParams);
      return;
    }
    searchParams.set("type", type);
    setSearchParams(searchParams);
    dispatch(
      saveStepperData<Partial<UpgradeAccountRequest>>({
        tierType: +type.split("tier")[1] as TierType,
      }),
    );
  };

  const handleClickCancel = () => {
    searchParams.delete("type");
    setSearchParams(searchParams);
    dispatch(
      saveStepperData<Partial<UpgradeAccountRequest>>({
        tierType: 0 as TierType,
      }),
    );
    onClickCancel?.();
  };

  if (viewFeatures) return null;
  return (
    <div className="d-flex flex-column gap-3">
      {selectUpgradeAcctType.map(({ name, description, type }) => (
        <button
          key={name}
          className={`border-1 w-auto rounded-pill d-flex align-items-center gap-4 text-dark ${styles.selectAccTypeBtn}`}
          onClick={() => handleClickUpgradeAcctType(type)}
          data-selected-type={type.includes(`${tierType}`)}
        >
          <div className={`bg-warning-subtle p-2 rounded-circle`}>
            <NewIcon />
          </div>
          <div className="d-flex flex-column align-items-start">
            <b>{name}</b>
            <span className="text-lg-nowrap text-start">{description}</span>
          </div>
        </button>
      ))}
      <div className="d-flex flex-column flex-lg-row gap-2 gap-lg-0 justify-content-between">
        <button onClick={handleClickCancel}>Cancel</button>
        <button
          className={`coloredBtn ${!tierType ? "disabled" : ""}`}
          onClick={() =>
            handleClickUpgradeAcctType(`tier${tierType}` as "tier2", true)
          }
          disabled={!tierType}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default SelectAccountUpgradeType;
